import React from 'react';
import { Form } from 'antd';
import { I18n } from '@aws-amplify/core';

import { TaskSelect } from '@/components/ui/Inputs/TaskSelect';
import { useBeraReportV2 } from '@/context/BeraReportV2';

const { useFormInstance, useWatch } = Form;

const TASK_ID_FIELD = 'task_id';

export function Tlid(): JSX.Element {
	const { file, jobSummary, tasks, isFetchingTasks } = useBeraReportV2();

	const form = useFormInstance();

	const fieldName = [file.id, TASK_ID_FIELD];

	const taskId = useWatch(fieldName, form);

	function handleSelectTask(id: string): void {
		form.setFields([{ name: fieldName, value: id, touched: true }]);
	}

	function handleClearTask(): void {
		form.setFields([{ name: fieldName, value: undefined, touched: true }]);
	}

	return (
		<Form.Item
			name={fieldName}
			label={I18n.get('Task list ID (TLID)')}
			labelCol={{ span: 24 }}
			rules={[{ required: true, message: I18n.get('Select the task') }]}
		>
			<TaskSelect
				taskId={taskId}
				cycleId={jobSummary?.cycle_id}
				tasks={tasks}
				loading={isFetchingTasks}
				disabled={isFetchingTasks}
				fieldName={fieldName}
				handleSelectTask={handleSelectTask}
				handleClearTask={handleClearTask}
			/>
		</Form.Item>
	);
}
